import { handleActions } from 'redux-actions';
import action from '../action';
import { produce } from 'immer';

const { actionTypes } = action;
const { insights } = actionTypes;

const defaultState = {
  insightsData: {},
  valueDriverManageData: null,
};

export default handleActions(
  {
    [insights.CHANGE_GD_PRINCIPLE_DATA]: (state, action) =>
      produce(state, (draft) => {
        const { data = {}, id } = action.payload;
        if (id && data) {
          if (!draft.insightsData[id]) {
            draft.insightsData[id] = {};
          }

          Object.keys(data).forEach((key) => {
            draft.insightsData[id][key] = data[key];
          });
        }
      }),
    [insights.CHANGE_VALUE_DRIVER_MANAGE_DATA]: (state, action) =>
      produce(state, (draft) => {
        action.payload !== undefined &&
          (draft.valueDriverManageData = action.payload);
      }),
  },
  defaultState,
);
